/* src/app/order/components/additional-questions/audit-dates/pre-audit-checkbox/pre-audit-checkbox.style.scss */
.pre-audit {
  display: flex;
  flex-direction: column;
  min-height: 145px;
}
.pre-audit .pre-audit-checkbox-wrapper {
  display: flex;
}
.pre-audit .pre-audit-checkbox-wrapper label {
  font-size: 0.813rem;
  font-weight: bold;
  position: relative;
  padding-left: 5px;
}
.pre-audit .pre-audit-info {
  min-height: 64px;
  font-size: 0.75rem;
  line-height: 1.33;
  margin-top: 10px;
  margin-bottom: 20px;
}
.pre-audit .info-message {
  color: #ee7f00;
}
.pre-audit .info-icon {
  vertical-align: middle;
  fill: #91bbff !important;
}
.pre-audit .info-icon:hover {
  fill: #0044b1 !important;
  cursor: pointer;
}
.pre-audit .info-icon.clicked {
  fill: #0044b1 !important;
}
@media screen and (max-width: 1096px) {
  .pre-audit {
    min-height: unset;
    margin-bottom: 15px;
  }
  .pre-audit .pre-audit-checkbox-wrapper label {
    top: 0;
    display: flex;
  }
}
/*# sourceMappingURL=pre-audit-checkbox.style.css.map */
